module.exports = __webpack_public_path__ + "static/img/right-svgrepo-com.44eca69b.svg";